var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCurveRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10237_65001",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7797 24.7062C24.4357 24.4004 24.4047 23.8737 24.7105 23.5297L26.811 21.1666L23 21.1666C21.9362 21.1666 21.1884 21.1673 20.6049 21.2149C20.0311 21.2618 19.6899 21.35 19.4259 21.4845C18.8771 21.7641 18.4309 22.2103 18.1512 22.7591C18.0167 23.0232 17.9285 23.3644 17.8817 23.9381C17.834 24.5217 17.8333 25.2694 17.8333 26.3333V27.8333C17.8333 28.2936 17.4602 28.6667 17 28.6667C16.5398 28.6667 16.1667 28.2936 16.1667 27.8333V26.2971C16.1667 25.2777 16.1667 24.4618 16.2205 23.8024C16.2758 23.1256 16.392 22.5406 16.6662 22.0025C17.1056 21.1401 17.8068 20.4389 18.6692 19.9995C19.2074 19.7253 19.7923 19.6091 20.4691 19.5538C21.1285 19.4999 21.9444 19.4999 22.9639 19.4999L26.8109 19.4999L24.7105 17.137C24.4047 16.793 24.4357 16.2663 24.7797 15.9605C25.1237 15.6547 25.6504 15.6857 25.9562 16.0297L29.2895 19.7796C29.5702 20.0954 29.5702 20.5712 29.2895 20.8869L25.9562 24.637C25.6504 24.981 25.1237 25.0119 24.7797 24.7062Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10237_65001)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 0 0 1 32 12)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCurveRight);
export default __webpack_public_path__ + "static/media/arrow-curve-right.cce29e5e695ccfd4c5f15bd8b33a26d9.svg";
export { ForwardRef as ReactComponent };